module.exports = __webpack_public_path__ + "static/event_img3M@2x-281cfbd080553ceef67b09cb356c39b0.png";